// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__khsov","col":"styles_col__1QwK8"};